import React, { useState, useEffect } from 'react';
import P5Wrapper from 'react-p5-wrapper';
import sketch from './sketch';
import travela from './travela.svg';

const Fourier = (props) => {
  const [image, setImage] = useState(null);

  const [points, setPoints] = useState([]);

  useEffect(() => {
    const svg = document.querySelector('svg');
    if( svg ){
      const path = svg.querySelectorAll('path')[0];
      const coordinates = [];
      const pathLength = path.getTotalLength();
      for(let i=0;i<pathLength;i++){
        const point = path.getPointAtLength(i);
        coordinates.push({ x: point.x, y: point.y});
      }
      setPoints(coordinates);
      console.log(JSON.stringify(coordinates));
    }

  }, []);


  return (
    <div>
      <div className="canvas">
        <P5Wrapper sketch={sketch} points={points} />
      </div>
    </div>
  );
};

Fourier.propTypes = {};

Fourier.defaultProps = {};

export default Fourier;
